/**
 * Energy Efficiency — frontend behaviour.
 *
 * Static section + blur-reveal entrance. The active/hover state is pure CSS.
 * The first import pulls in this section's CSS so it ships as one bundle.
 */
import './style.scss';
import { gsap } from 'gsap';

function init() {
	const sections = document.querySelectorAll('[data-energy]');
	if (!sections.length) return;

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	sections.forEach((section) => {
		const targets = section.querySelectorAll('[data-energy-anim], [data-energy-box]');
		if (!targets.length) return;

		if (reduced) {
			targets.forEach((el) => { el.style.opacity = '1'; el.style.transform = 'none'; });
			return;
		}

		gsap.set(targets, { opacity: 0, y: 24, filter: 'blur(10px)' });

		const io = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				io.unobserve(entry.target);
				// clearProps:'transform' so GSAP's leftover inline transform
				// doesn't pin the boxes and break the CSS :hover state.
				gsap.to(targets, {
					opacity: 1, y: 0, filter: 'blur(0px)',
					duration: 0.8, ease: 'power3.out', stagger: 0.1,
					clearProps: 'transform',
				});
			});
		}, { rootMargin: '0px 0px -15% 0px', threshold: 0.1 });

		io.observe(section);
	});
}

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
